var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasPdf)?_c('embed',{staticClass:"h-adjusted",attrs:{"type":"application/pdf","src":_vm.imageSrc}}):(_vm.hasImage)?_c('b-img',{staticClass:"mb-3 h-adjusted",attrs:{"src":_vm.imageSrc,"fluid":"","block":"","rounded":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }